import React from 'react';

const ActivClients = () => {
    return (
        <div>
            <h1>Clients actius</h1>
        </div>
    );
};

export default ActivClients;